<div class="bo-auth-brand">
    <div class="bo-auth-brand__mark" aria-hidden="true">
        <ng-content select="[brand-icon]">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M7 7l10 10M17 7L7 17"></path>
            </svg>
        </ng-content>
    </div>
    <div>
        <p class="bo-auth-brand__name">{{ appName() }}</p>
        <p class="bo-auth-brand__tagline">{{ tagline() }}</p>
    </div>
</div>